// Error code constants matching backend error codes
// These must stay in sync with backend/utils/errors.go and error_codes.go

export const ERROR_CODES = {
  // Authentication & Session Errors
  INVALID_TOKEN: 'invalid_token',
  SESSION_EXPIRED: 'session_expired',
  AUTH_INVALID: 'auth_invalid',
  AUTH_EXPIRED: 'auth_expired',
  INVALID_SESSION: 'session_invalid',
  SESSION_CREATE_FAILED: 'session_create_failed',
  SESSION_COOKIE_NOT_FOUND: 'session_cookie_not_found',
  CLAIM_NOT_FOUND_OR_INVALID: 'claim_not_found_or_invalid',
  INVALID_CLIENT: 'invalid_client',
  INVALID_REDIR: 'invalid_redir',
  UNAUTHORIZED: 'unauthorized',
  UNAUTHORIZED_DEVICE: 'authorized_device',

  // User & Account Errors
  USER_NOT_FOUND: 'user_not_found',
  ACCOUNT_FAILED: 'account_failed',
  ACCOUNT_BLOCKED: 'account_blocked',
  PASS_INVALID: 'pass_invalid',
  USER_ALREADY_ENROLLED: 'user_already_enrolled',
  EMAIL_ALREADY_INUSE: 'email_already_inuse',
  USER_ID_NOT_FOUND: 'user_id_not_found',

  // Company & App Errors
  COMPANY_INVALID: 'company_invalid',
  COMPANY_ALREADY_ENROLLED: 'company_enrolled',
  APP_ALREADY_ENROLLED: 'app_enrolled',
  APP_NOT_EXIST: 'app_not_exist',
  APP_DISABLED: 'app_disabled',
  APP_ACCESS_PROHIBITED: 'app_access_prohibited',
  ACCESS_UNVERIFIED: 'access_unverified',
  ACCESS_NOT_FOUND: 'access_not_found',
  FAILED_GET_COMPANIES: 'failed_get_companies',

  // Device Errors
  DEVICE_NOT_FOUND: 'device_not_found',
  DEVICE_LIMIT_REACHED: 'device_limit_reached',
  MAX_DEVICE_REACHED: 'max_device_reached',
  DEVICE_ADD_FAILED: 'device_add_failed',
  DEVICE_ACTIVATION_FAILED: 'device_activation_failed',

  // Storage/File Errors
  FILE_NOT_FOUND: 'missing_file',
  FILE_UPLOAD_FAILED: 'file_upload_failed',

  // General Errors
  DATA_ERROR: 'data_error',
  INTERNAL_ERROR: 'internal_error',
  INVALID_INPUT: 'invalid_input',
  INCOMPLETE_PARAM: 'incomplete_param',

  // Network Errors (frontend specific)
  NETWORK_ERROR: 'network_error',
  TIMEOUT: 'timeout',
  CONNECTION_REFUSED: 'conn_refused',

  // Generic Errors
  SERVICE_ERROR: 'service_error',
  TEMP_UNAVAILABLE: 'temp_unavail',
} as const;

// Type for error codes
export type ErrorCode = typeof ERROR_CODES[keyof typeof ERROR_CODES];

// Success code
export const SUCCESS_CODE = '200';

// Authentication error codes that should trigger logout
export const AUTH_ERROR_CODES: ErrorCode[] = [
  ERROR_CODES.INVALID_TOKEN,
  ERROR_CODES.SESSION_EXPIRED,
  ERROR_CODES.AUTH_INVALID,
  ERROR_CODES.AUTH_EXPIRED,
  ERROR_CODES.INVALID_SESSION,
  ERROR_CODES.SESSION_COOKIE_NOT_FOUND,
  ERROR_CODES.UNAUTHORIZED,
];

// Retryable error codes
export const RETRYABLE_ERROR_CODES: ErrorCode[] = [
  ERROR_CODES.NETWORK_ERROR,
  ERROR_CODES.TIMEOUT,
  ERROR_CODES.CONNECTION_REFUSED,
  ERROR_CODES.TEMP_UNAVAILABLE,
  ERROR_CODES.SERVICE_ERROR,
];